import { useMemo } from 'react';
import Iframe from 'react-iframe';

import { NotFound, Wrapper } from '@/components';
import { useTranslation } from 'react-i18next';
import { useCampaign } from '@/hooks/client';

import styles from './CampaignPageSummary.module.css';

interface CampaignPageSummaryProps {
  campaignId: string;
}

export function CampaignPageSummary({ campaignId }: CampaignPageSummaryProps) {
  const { data = {}, isLoading } = useCampaign(campaignId);
  const { t } = useTranslation();

  const memoData = useMemo(() => data as Api.Client.Campaign, [data]);

  if (!memoData?.report_url) {
    return (
      <Wrapper isLoading={isLoading} campaignId={campaignId}>
        <div className={styles.campaignPageSummaryNotFound}>
          <NotFound text={t('campaignPageSummary.notFound')} />
        </div>
      </Wrapper>
    );
  }

  return (
    <>
      <Iframe className={styles.campaignPageSummary} url={memoData?.report_url} />

      {!isLoading && <div className={styles.campaignPageSummaryOverlay} />}
    </>
  );
}
